module.exports = __webpack_public_path__ + "static/media/UNFI-BNB.4bc103a6.svg";